<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="4">
					<!--PWA NO-->
					<sf-input-group
						:label="getMessage_('QWCC000969')"
						:inputValue="popupSearchParams.pwaNo"
						:onChange="value => onChangePopupSearchParam({ key: 'pwaNo', value })"
					/>
				</el-col>
				<el-col :span="4">
					<!--딜러점-->
					<sf-input-group
						:label="getMessage_('QWCC000959')"
						:inputValue="popupSearchParams.dlrCpnyCd"
						:onChange="value => onChangePopupSearchParam({ key: 'dlrCpnyCd', value })"
						:disabled="isMqyStation"
					/>
				</el-col>
				<el-col :span="4">
					<!--차량 VIN-->
					<sf-input-group
						:label="getMessage_('QWCC000960')"
						:inputValue="popupSearchParams.carVin"
						:onChange="value => onChangePopupSearchParam({ key: 'carVin', value })"
					/>
				</el-col>
			</el-row>

			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/ceqi/PwaApcn/store/helpers';
import qmsUtils from '@/store/qms/api';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {};
	},
	components: {},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	async created() {
		try {

			let partNer = true;

			//협력사일경우
			if (partNer) {
				let result = await qmsUtils.getDeptNm(this.user.deptCd);

				this.onChangePopupSearchParam({ key: 'dlrCpnyCd', value: result.deptCd });
				// this.onChange({key: 'dlrCpnyCd', value: result.deptCd });
				
			}
			await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	},
	methods: {
		...serviceMethods,
		searchList() {
			this.$sf_toggleLoading(true);
			let partNer = true;

			//협력사일경우
			if (partNer) {
				this.onChangePopupSearchParam({ key: 'dlrCpnyCd', value: this.user.deptCd });
			}
			
			this.getPopupPwaApcnList_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		onChangePopupSearchParam({ key, value }) {
			this.setPopupSearchParam_({ key, value });
		}
	}
};
</script>

<style></style>
